// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._hotkeyList_pf97p_2 {
	--form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));
}
._hotkeyList__heading_pf97p_6 {
	font-weight: bold;
	margin-inline: var(--form-element-label-offset);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcHotkeyList-gAZN0WIu.css"],"names":[],"mappings":";AACA;CACC,8FAA8F;AAC/F;AACA;CACC,iBAAiB;CACjB,+CAA+C;AAChD","sourcesContent":["\n._hotkeyList_pf97p_2 {\n\t--form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));\n}\n._hotkeyList__heading_pf97p_6 {\n\tfont-weight: bold;\n\tmargin-inline: var(--form-element-label-offset);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
